import { ChangeDetectionStrategy, Component } from '@angular/core';

import { MenuItemWrapper } from '../menu-utils/menu-utils';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ds-menu-item',
  template: `<li
    class="ds-menu-item"
    [attr.aria-current]="$_isSelected() ? 'true' : null"
  >
    <ng-content></ng-content>
  </li>`,
})
export class MenuItemComponent extends MenuItemWrapper { }
